import { httpGet, httpPost } from '../../../utils/api.utils';
import { REQUEST_TYPES_ID as RequestType } from '../../../constants/external-constants';

export async function getAddresses(dispatch, actionType, value, showOtherAddress = false) {
    var res = await httpPost(getUrlLocationAddress(showOtherAddress), { countryCode: value });

    if (res != null) {
        dispatch({ type: actionType, data: res });
    } else {
        dispatch({ type: actionType, data: [] });
    }
}

export async function updatePlanTypes(dispatch, actionType, id, circuitCategoryId) {
    var res = await httpGet('external/orderRequest/GetPlanByVendorByCircuitType/' + id + '/' + circuitCategoryId);
    if (res != null) {
        dispatch({ type: actionType, data: res });
    } else {
        dispatch({ type: actionType, data: [] });
    }

    return res != null && res.ok !== false;
}

export async function updatePlanTypesByCircuitType(dispatch, actionType, id, circuitTypeId) {
    var res = await httpGet('external/orderRequest/getPlanByVendorByCircuitType/' + id + '/' + circuitTypeId);
    if (res != null && res.length > 0) {
        dispatch({ type: actionType, data: res });
    } else {
        dispatch({ type: actionType, data: [] });
    }
}

export async function getVendorDetails(dispatch, actionType, defaultState, id) {
    var res = await httpPost('external/orderRequest/getVendorDetails', { VendorDetailId: id });
    if (res != null) {
        dispatch({ type: actionType, data: res });
    } else {
        dispatch({ type: actionType, data: { ...defaultState } });
    }
    return res != null;
}

export async function getUserLocation(dispatch, actionType, requestId) {

    let url = getUrlUserLocation(requestId);

    var res = await httpPost(url, { EmployeeId: parseInt(sessionStorage.EmployeeID) });

    if (res && Object.keys(res).length > 0) {
        dispatch({ type: actionType, data: res });
    } else {
        dispatch({ type: actionType, data: {} });
    }
}

export function addZeroes(num) {
    var numberAsString = num.toString();

    if (numberAsString.indexOf('.') === -1) {
        num = num.toFixed(2);
        numberAsString = num.toString();
    } else if (numberAsString.split(".")[1].length < 3) {
        num = num.toFixed(2);
        numberAsString = num.toString();
    }

    return numberAsString
}

function getUrlUserLocation(id) {
    switch (id) {
        case RequestType.simReplacement:
            return 'external/replaceSim/getUserLocation';
        case RequestType.deviceReplacement:
        case RequestType.accessory:
        case RequestType.changeVendor:
            return 'external/replaceDevice/getUserLocationAddress';
        default:
            return '';
    }
}

function getUrlLocationAddress(showOtherAddress) {
    let url = 'external/orderRequest/getAddresses';
    if (showOtherAddress) {
        url = 'external/orderRequest/getOtherAddresses';
    }
    return url;
}